<template>
	<b-modal id="add-certificado" size="lg" @show="resetModal" @ok="handleEnvio">
		<template v-slot:modal-title>
			<label>Creación Certificado</label>
		</template>
		<b-form-group>
			<label>
				Seleccion el curso destino
			</label>
			<v-select
				placeholder="Listado cursos..."
				:options="activeCurso"
				label="tituloCurso"
				v-model="selectCurso"
				@input="seleccionCurso(listadoCurso)"
			>
				<template slot="option" slot-scope="option">
					{{ option.tituloCurso }}
				</template>
			</v-select>
			<span v-if="error.idCurso" style="color:red">
				{{ error.idCurso }}
			</span>
		</b-form-group>

		<b-form-group label="Selecciona el modulo">
			<b-form-select
				v-model="selectModulo"
				:options="optionModulo"
				:disabled="booleanModulo"
			>
			</b-form-select>
		</b-form-group>

		<b-form-group label="Nombre Certificado">
			<b-form-input
				v-model="certificado.nombre"
				placeholder="Ingresa el nombre del certificado..."
				v-on:keyup="error.nombre = false"
			>
			</b-form-input>
			<span v-if="error.nombre" style="color:red">{{ error.nombre }}</span>
		</b-form-group>

		<b-form-group label="Nombre Certificado">
			<ckeditor v-model="certificado.contenido"></ckeditor>
			<span v-if="error.contenido" style="color:red">
				{{ error.contenido }}
			</span>
		</b-form-group>

		<b-form-group label="Imagen Cabecera">
			<b-form-file
				v-model="certificado.imgCabecera"
				@change="changeCabecera($event)"
				placeholder="Arrastra tu archivo hasta aquí..."
				drop-placeholder="Busca tu archivo..."
			></b-form-file>
			<br />
			<small>El archivo no puede superar los 200mb. </small>
			<span v-if="error.imgCabecera" style="color:red">
				{{ error.imgCabecera }}
			</span>
		</b-form-group>

		<b-form-group label="Imagen Pie Pagina">
			<b-form-file
				v-model="certificado.imgPiePagina"
				@change="changePiePagina($event)"
				placeholder="Arrastra tu archivo hasta aquí..."
				drop-placeholder="Busca tu archivo..."
			></b-form-file>
			<br />
			<small>El archivo no puede superar los 200mb. </small>
			<span v-if="error.imgPiePagina" style="color:red">
				{{ error.imgPiePagina }}
			</span>
		</b-form-group>

		<template v-slot:modal-footer="{ ok, cancel }">
			<b-button @click="cancel()">
				Cancelar
			</b-button>
			<b-button v-if="load != true" variant="primary" @click="ok()">
				Aceptar
			</b-button>
			<b-button v-else variant="primary">
				<b-spinner small type="grow"></b-spinner>
				Cargando por favor espere...
			</b-button>
		</template>
		<toast ref="toast" />
	</b-modal>
</template>
<script>
import { mapState, mapActions } from "vuex";
import toast from "@/components/toastComponent";
export default {
	components: {
		toast
	},
	data() {
		return {
			load: false,
			file: "",
			certificado: {
				nombre: null,
				contenido: null,
				imgCabecera: null,
				imgPiePagina: null
			},
			listadoCurso: [],
			selectCurso: "",

			booleanModulo: false,
			selectModulo: null,
			optionModulo: [
				{
					value: null,
					text: "Selecciona el curso para la busqueda de modulos."
				}
			],
			camposVacio: {},
			error: {
				idCurso: "",
				nombre: "",
				contenido: "",
				imgCabecera: "",
				imgPiePagina: ""
			}
		};
	},
	computed: {
		...mapState("certificado", ["jsonCertificado"]),
		...mapState("certificado", ["jsonInstanciaCertificado"]),
		...mapState('alumno',['jsonCoordinadora']),
		...mapState('curso',['activeCurso'])
	},
	methods: {
		handleEnvio(bvModalEvt) {
			// Prevent modal from closing
			bvModalEvt.preventDefault();
			
			const valorCampos = this.camposVacios();
		
			if (valorCampos) {
				this.load = true;
				this.insertAlumno();
			}

		},
		resetModal() {
			//Limpia valores cuando se cierra la modal
			this.error = {
				idCurso: "",
				nombre: "",
				contenido: "",
				imgCabecera: "",
				imgPiePagina: ""
			};

			this.certificado = {
				nombre: null,
				contenido: null,
				imgCabecera: null,
				imgPiePagina: null
			};
			this.selectModulo = null;
			this.selectCurso = null;
			this.msgAceptar = "Aceptar";
		},
		camposVacios() {
			var booleanEstado = true;
			if (!this.selectCurso) {
				this.error.idCurso = "Este campo es obligatorio";
				booleanEstado = false;
			}
			if (!this.certificado.nombre) {
				this.error.nombre = "Este campo es obligatorio";
				booleanEstado = false;
			}
			if (!this.certificado.contenido) {
				this.error.contenido = "Este campo es obligatorio";
				booleanEstado = false;
			}
			if (!this.certificado.imgCabecera) {
				this.error.imgCabecera = "Este campo es obligatorio";
				booleanEstado = false;
			}
			if (!this.certificado.imgPiePagina) {
				this.error.imgPiePagina = "Este campo es obligatorio";
				booleanEstado = false;
			}

			return booleanEstado;
		},

		changeCabecera() {
			this.certificado.imgCabecera = event.target.files[0];
			this.error.imgCabecera = "";
		},
		changePiePagina() {
			this.certificado.imgPiePagina = event.target.files[0];
			this.error.imgPiePagina = "";
		},
		insertAlumno() {
			var form = new FormData();
			form.append("idCurso", this.selectCurso.idCurso);
			form.append("idModulo", this.selectModulo);
			form.append("nombreCertificado", this.certificado.nombre);
			form.append("contenido", this.certificado.contenido);
			form.append("imgCabecera", this.certificado.imgCabecera);
			form.append("imgPiePagina", this.certificado.imgPiePagina);

			this.axios
				.post("api/creacionCertificado", form)
				.then(res => {
					this.load = false;
					
					const arrayToast = {
						msg: "Se ha creado el certificado con exito",
						title: "Exito",
						variant: "success"
					};
					const dataJsonCertificado = {
						idCertificado: res.data.certificado.idCertificado,
						nombreCertificado: res.data.certificado.nombreCertificado,
						contenido: res.data.certificado.contenido,
						curso: res.data.curso,
						estado: 1
					};

					this.jsonCertificado.push(dataJsonCertificado);
					this.$refs.toast.makeToast(arrayToast);
				})
				.catch(err => console.log(err));
		},
		seleccionCurso() {
			this.getModulosCurso(this.selectCurso.idCurso);
			this.error.idCurso = "";
		},
		getCursoCoordinadora() {
			this.axios
				.get("api/getCursoCoordinadora")
				.then(res => {
					const listadoCursos = res.data.listadoCursos;

					// console.log('hola');

					// console.log(this.jsonCoordinadora);

				 this.listadoCurso = listadoCursos.map(elem => ({
						idCurso: elem.idCurso,
						tituloCurso: `#${elem.idCurso} ${elem.tituloCurso}`
					})); 
				})
				.catch(err => console.log(err));
		},
		getModulosCurso(idCurso) {
			this.axios
				.get("api/getTotalModulos/" + idCurso)
				.then(res => {
					const listadoModulos = res.data.modulos;

					const modulos = [
						{ value: null, text: "Haz click para seleccionar un modulo." }
					];
					listadoModulos.map(elem =>
						modulos.push({ value: elem.idModulo, text: elem.nombre })
					);

					this.booleanModulo = false;
					this.optionModulo = modulos;

					if (listadoModulos.length == 0) {
						this.optionModulo.push({
							value: null,
							text: "El curso no se encuentra con modulos activos."
						});
						this.booleanModulo = true;
					}

					this.selectModulo = this.optionModulo[0].value;
				})
				.catch(err => console.log(err));
		}
	},
	mounted() {
		//this.getCursoCoordinadora();
	}
};
</script>
